export default "__VITE_ASSET__BYb256u7__"